var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import api from "../../utils/api/api.utils";
import { mapObjectWithTimeZonedDatesToUtcIsoString } from "../../utils/date.utils";
import { appendQueryParams } from "../../utils/url.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./contract.constants";
export var getPagedBase = (_a = generateApi(GENERATOR_PARAMS), _a.getPaged), getDetail = _a.getDetail, getCount = _a.getCount, getInfiniteLoad = _a.getInfiniteLoad, update = _a.update, create = _a.create, remove = _a.remove, removeMembers = _a.removeMembers, addMembers = _a.addMembers;
export var index = function (params) {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(params.id, "/index"), {
        isV2: true,
        data: {
            newPrice: params.newPrice,
            retroactivityMonths: params.retroactivityMonths,
            forceFullIndexation: params.forceFullIndexation,
        },
    });
};
export var indexAskOwner = function (params) {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(params.id, "/index-ask-owner"), { isV2: true });
};
export var indexSkip = function (params) {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(params.id, "/index-skip"), {
        isV2: true,
        data: { notifyTenant: params.notifyTenant },
    });
};
export var renew = function (params) {
    var id = params.id, rest = __rest(params, ["id"]);
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/renew"), {
        isV2: true,
        data: mapObjectWithTimeZonedDatesToUtcIsoString(rest),
    });
};
export var activateLegal = function (params) {
    var contractId = params.contractId;
    return api.post("".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(contractId, "/activate-legal"), { isV2: true });
};
export var cancel = function (contractId, params) {
    var data = params;
    return api.patch("".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(contractId, "/cancel"), {
        isV2: true,
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data),
    });
};
export var deleteCancellation = function (contractId, params) {
    var data = params;
    return api.patch("".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(contractId, "/delete-cancellation"), {
        isV2: true,
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data),
    });
};
export var getIndexInfoSimulation = function (contractId, params) {
    var forceFullIndexation = params.forceFullIndexation, newPrice = params.newPrice, retroactivityMonths = params.retroactivityMonths;
    return api.get(appendQueryParams({
        path: "/contracts/".concat(contractId, "/index-simulation-info"),
        queryParams: {
            forceFullIndexation: forceFullIndexation,
            newPrice: newPrice,
            retroactivityMonths: retroactivityMonths,
        },
    }), {
        isV2: true,
    });
};
export var sendToRentioMove = function (params) {
    var contractId = params.contractId, data = params.data;
    return api.post("".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(contractId, "/send-to-rentio-move"), {
        isV2: true,
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data),
    });
};
export var requestFinalInvoice = function (params) {
    var contractId = params.contractId;
    return api.post("".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(contractId, "/rentio-move-request-final-invoice"), {
        isV2: true,
    });
};
export var getBanqupBankAccountByContractId = function (contractId) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/contracts/".concat(contractId, "/banqup-bank-account"), {
                    isV2: true,
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
